import { createSlice } from '@reduxjs/toolkit'
import Constants from '../../Constants';
import { earlierDate, currentDate } from '../../services/Util';

var startDate = currentDate();
startDate = startDate.subtract(31, "days");
startDate = earlierDate(startDate,1,"months");
var endDate = currentDate();
var newDateRange = [startDate?._d,endDate._d]

export const ReportsSlice = createSlice({
  name: 'reports',
  initialState: {
    dateRange: newDateRange,
    department: Constants.BLANK
  },
  reducers: {
    rangeSelected: (state, action) => {
      state.dateRange = action.payload
    },
    departmentSelected : (state, action) => {
      state.department = action.payload
    },
    reset: (state) => {
      state.dateRange = newDateRange;
      state.department = Constants.BLANK;
    },
  },
})

export const { rangeSelected, departmentSelected, reset } = ReportsSlice.actions

export default ReportsSlice.reducer